import hubspotHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/hubspot-header.png';
import hubspotSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/hubspot-section1.png';
import hubspotSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/hubspot-section2.png';
import hubspotSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/hubspot-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_MARKETING: PageblockData = {
  headerData: {
    headerText: 'Automate HubSpot-to-Salesforce Campaign Syncing',
    subHeaderText:
      'Visualize and manage campaign workflows across platforms, ensuring both HubSpot and Salesforce stay in sync for complete marketing attribution.',
    imgSrc: hubspotHeader,
    imgAlt: 'Hubspot header',
    name: 'Hubspot',
  },
  pageTitle: 'Bridge the gap between marketing and sales with seamless campaign attribution',
  section1: {
    imgSrc: hubspotSection1,
    imgAlt: 'Hubspot section img',
    title: 'Manage campaigns between Salesforce and HubSpot in one place',
    content:
      'Prevent duplicate records, mismatched campaign data, and attribution gaps by ensuring marketing and sales operate with a single, accurate source of truth.',
  },
  section2: {
    imgSrc: hubspotSection2,
    imgAlt: 'Hubspot section 2 img',
    title: 'Automate campaign enrollment & syncing',
    content:
      'Define automated rules in HubSpot to instantly sync contacts into Salesforce campaigns, eliminating manual effort and keeping systems aligned.',
  },
  section3: {
    imgSrc: hubspotSection3,
    imgAlt: 'Hubspot section 3 img',
    title: 'Unify marketing attribution reporting',
    content:
      'Combine HubSpot and Salesforce data into a single source of truth, creating reports that show the true ROI of your marketing campaigns.',
  },
};
